module.exports = __webpack_public_path__ + "img/13d.035cc16d.svg";